import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";
import FluentShield from "../../assets/img/fluent_shield.svg";
import { formatPropertyAddress, getUserDisplayName } from "../../helper/common";
import { DownloadIcon } from "../../helper/svgHelper";

const LightningIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2L3 14H11L10 22L21 10H13L13 2Z"
      fill="#A3EB64"
      stroke="#A3EB64"
      strokeWidth="1.5"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

const AwardInsuranceConfirmPopup = ({
  show,
  onHide,
  onConfirm,
  selectedTenant,
  property,
  currentLang,
  isInsuranceToggleEnabled,
  preFilledInsuranceDocument,
  isInsurable,
}) => {
  const { _t } = useTranslator();
  const [addInsurance, setAddInsurance] = useState(
    isInsuranceToggleEnabled || false
  );

  const propertyName = formatPropertyAddress(property, currentLang);

  const handleConfirm = () => {
    onHide();
    onConfirm(addInsurance);
  };

  const tenants = selectedTenant?.flatMap((s) => {
    const isApplication = s?.application_id?.participants?.length > 0;
    return isApplication
      ? s?.application_id?.participants?.map((p) => p?.tenant_info)
      : s?.tenantid;
  });

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardInsuranceConfirmModal"
    >
      <Modal.Header>
        <h2 className="aic-title">{_t("awardProperty")}</h2>
        <div className="cursor-pointer" onClick={onHide}>
          <img src={Cancelimg} alt="close" className="canceicon topRightIcon" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <p className="aic-desc">
          {_t("youAreAboutToAward")}{" "}
          <span className="aic-prop-name">{propertyName}</span>{" "}
          {_t("toTheFollowingTenants")}:
        </p>

        <div className="aic-chips">
          {tenants?.map((tenant, idx) => (
            <span key={idx} className="aic-chip">
              {getUserDisplayName(tenant) || tenant?.tenantid?.label || ""}
            </span>
          ))}
        </div>

        {isInsurable && (
          <div className="aic-insurance-card">
            <div className="aic-insurance-icon">
              <LightningIcon />
            </div>
            <div className="aic-insurance-text">
              <p className="aic-insurance-title">
                {isInsuranceToggleEnabled
                  ? _t("addSkorRentDefaultInsurance")
                  : _t("addSkorRentDefaultInsuranceTogglerDisabled")}
              </p>
              <p className="aic-insurance-subtitle">
                {isInsuranceToggleEnabled
                  ? _t("insuranceContractingDescription")
                  : _t("insuranceContractingDescriptionTogglerDisabled")}
              </p>
              {preFilledInsuranceDocument && (
                <a
                  href={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${preFilledInsuranceDocument}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="aic-insurance-download-link"
                  onClick={(e) => e.stopPropagation()}
                >
                  <DownloadIcon />
                  {_t("downloadInsuranceProjectTemplate")}
                </a>
              )}
            </div>
            <label className="aic-toggle">
              <input
                type="checkbox"
                checked={addInsurance}
                onChange={() => setAddInsurance((prev) => !prev)}
              />
              <span className="aic-toggle-slider" />
            </label>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="aic-footer">
        <button className="aic-btn-cancel" onClick={onHide} type="button">
          {_t("cancel")}
        </button>
        <button className="aic-btn-award" onClick={handleConfirm} type="button">
          {addInsurance && <img src={FluentShield} alt="" />}
          {_t("awardProperty")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AwardInsuranceConfirmPopup;
